var _style, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPreciseCaptures2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 508.3 500",
    style: {
      enableBackground: "new 0 0 508.3 500"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#ED5338;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M75,225h16.7v16.7H75V225z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M108.3,225H125v16.7h-16.7V225z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M308.3,483.3H181.4L125.5,275h16.2c13.8,0,25-11.2,25-25v-25h25c4.6,0,8.3-3.7,8.3-8.3v-58.3 c0-4.6-3.7-8.3-8.3-8.3h-25v-16.7c0-13.8-11.2-25-25-25h-8.3V91.7c0-9.2-7.5-16.7-16.7-16.7H83.3c-9.2,0-16.7,7.5-16.7,16.7v16.7 h-8.3c-13.8,0-25,11.2-25,25V250c0,13.8,11.2,25,25,25h16.2L18.6,483.3H0V500h308.3L308.3,483.3z M164.1,483.3h-55.8V275.4 L164.1,483.3z M183.3,166.7v41.7h-16.7v-41.7H183.3z M83.3,91.7h33.3v16.7H83.3V91.7z M50,250v-91.7h83.3v-16.7H50v-8.3 c0-4.6,3.7-8.3,8.3-8.3h83.3c4.6,0,8.3,3.7,8.3,8.3V250c0,4.6-3.7,8.3-8.3,8.3H58.3C53.7,258.3,50,254.6,50,250z M91.7,275.4v207.9 H35.9L91.7,275.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M351.7,110.4l11.8,11.7c3.5-3.5,7.3-6.6,11.3-9.4l-9.3-13.8C360.6,102.3,355.9,106.1,351.7,110.4L351.7,110.4z "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M381.7,259.8l6.4-15.4c-4.5-1.9-8.9-4.2-13-6.9l-9.2,13.9C370.8,254.6,376.2,257.5,381.7,259.8L381.7,259.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M331.9,140.1l15.4,6.4c1.9-4.5,4.2-8.9,6.9-13l-13.9-9.2C337,129.2,334.2,134.6,331.9,140.1L331.9,140.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M501.2,139.6l-15.4,6.4c1.9,4.5,3.3,9.2,4.3,14l16.3-3.3C505.3,150.9,503.6,145.1,501.2,139.6L501.2,139.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M434.6,264.9c5.9-1.2,11.7-2.9,17.2-5.2l-6.4-15.4c-4.5,1.9-9.2,3.3-14,4.3L434.6,264.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M416.5,250c-4.9,0-9.7-0.5-14.4-1.4l-3.2,16.4c5.8,1.1,11.8,1.7,17.8,1.7c0.3,0,0.7,0,1-0.1l-0.9-8.3V250 H416.5L416.5,250z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M469.7,228c-3.5,3.5-7.3,6.6-11.4,9.3l9.3,13.8c5-3.3,9.6-7.2,13.9-11.4L469.7,228z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M325,175v0.2l16.7-0.2c0-4.9,0.5-9.7,1.4-14.5l-16.4-3.2C325.6,163.1,325,169.1,325,175L325,175z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M501.4,210.1l-15.4-6.4c-1.9,4.5-4.2,8.9-6.9,13l13.9,9.3C496.3,220.9,499.1,215.6,501.4,210.1L501.4,210.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M326.8,193.1c1.2,5.9,2.9,11.7,5.2,17.2l15.4-6.4c-1.9-4.5-3.3-9.2-4.3-14L326.8,193.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M467.3,98.6c-5-3.3-10.3-6.2-15.9-8.4l-6.3,15.4c4.5,1.8,8.9,4.2,13,6.9L467.3,98.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M363.7,228.1c-3.5-3.5-6.6-7.3-9.3-11.3l-13.8,9.3c3.3,5,7.2,9.6,11.4,13.9L363.7,228.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M398.5,85.1c-5.9,1.2-11.7,3-17.2,5.3l6.4,15.4c4.5-1.9,9.2-3.3,14-4.3L398.5,85.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M434.2,85c-5.7-1.1-11.7-1.7-17.6-1.7h-0.3l0.3,16.7c4.9,0,9.7,0.5,14.4,1.4L434.2,85z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M490.2,189.6l16.4,3.2c1.2-5.9,1.7-11.9,1.7-17.9v-0.3l-16.7,0.3C491.7,179.9,491.2,184.8,490.2,189.6 L490.2,189.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M469.5,121.8c3.5,3.5,6.6,7.3,9.4,11.3l13.8-9.3c-3.3-5-7.2-9.6-11.5-13.8L469.5,121.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M220.9,142.8l250-141.7l8.2,14.5l-250,141.7L220.9,142.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M220.9,232.3l8.2-14.5l250,141.7l-8.2,14.5L220.9,232.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M369.1,189.2l25,25c1.6,1.6,3.7,2.4,5.9,2.4h0.3c2.3-0.1,4.5-1.1,6-2.8l58.3-66.7l-12.5-11l-52.5,60 l-18.7-18.7L369.1,189.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M375,384.9c4.3-1.4,7.3-5.4,7.3-9.9s-2.9-8.5-7.3-9.9c-14.8-4.7-18.7-8.6-23.4-23.4c-1.4-4.3-5.4-7.3-9.9-7.3 s-8.5,2.9-9.9,7.2c-4.7,14.8-8.6,18.7-23.4,23.4c-4.3,1.4-7.3,5.4-7.3,9.9s2.9,8.5,7.2,9.9c14.8,4.7,18.7,8.6,23.4,23.4 c1.4,4.3,5.4,7.3,9.9,7.3s8.5-2.9,9.9-7.2C356.3,393.6,360.2,389.6,375,384.9L375,384.9z M341.7,389.1c-3.5-6.1-8-10.6-14.1-14.1 c6.1-3.5,10.6-8,14.1-14.1c3.5,6.1,8,10.6,14.1,14.1C349.6,378.5,345.2,382.9,341.7,389.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M216.7,40.6c0,4.5,2.9,8.5,7.2,9.9c14.8,4.7,18.7,8.6,23.4,23.4c1.4,4.3,5.4,7.2,9.9,7.2h0 c4.5,0,8.5-2.9,9.9-7.2c4.7-14.8,8.6-18.7,23.4-23.4c4.3-1.4,7.3-5.4,7.3-9.9c0-4.5-2.9-8.5-7.2-9.9c-14.8-4.7-18.7-8.6-23.4-23.4 c-1.4-4.3-5.4-7.2-9.9-7.2h0c-4.5,0-8.5,2.9-9.9,7.2c-4.7,14.8-8.6,18.7-23.4,23.4C219.6,32,216.7,36,216.7,40.6L216.7,40.6z  M257.2,26.5c3.5,6.1,8,10.6,14.1,14.1c-6.1,3.5-10.6,8-14.1,14.1c-3.5-6.1-8-10.6-14.1-14.1C249.3,37,253.7,32.6,257.2,26.5z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPreciseCaptures2);
export default __webpack_public_path__ + "static/media/precise_captures_2.57b5de768c9f2c62a06709e111ff55ff.svg";
export { ForwardRef as ReactComponent };